import * as React from "react"
import { SVGProps } from "react"
const PatientCountAnimated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="animated"
    id="freepik_stories-person-with-a-cold"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500"
    {...props}
    width={250}
    height={250}
  >
    <style>
      {
        "svg#freepik_stories-person-with-a-cold:not(.animated) .animable {opacity: 0;}svg#freepik_stories-person-with-a-cold.animated #freepik--Shadows--inject-102 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-person-with-a-cold.animated #freepik--Plants--inject-102 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-person-with-a-cold.animated #freepik--Nightstand--inject-102 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-person-with-a-cold.animated #freepik--Character--inject-102 {animation: 6s Infinite  linear shake;animation-delay: 0s;}svg#freepik_stories-person-with-a-cold.animated #freepik--Tissues--inject-102 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-person-with-a-cold.animated #freepik--speech-bubble--inject-102 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes shake {                10%, 90% {                    transform: translate3d(-1px, 0, 0);                  }                  20%, 80% {                    transform: translate3d(2px, 0, 0);                  }                  30%, 50%, 70% {                    transform: translate3d(-4px, 0, 0);                  }                  40%, 60% {                    transform: translate3d(4px, 0, 0);                  }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }"
      }
    </style>
    <g
      id="freepik--Floor--inject-102"
      style={{
        transformOrigin: "249.79px 336.07px 0px",
      }}
      className="animable"
    >
      <ellipse
        id="freepik--floor--inject-102"
        cx={249.79}
        cy={336.07}
        rx={240.09}
        ry={139.57}
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "249.79px 336.07px 0px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadows--inject-102"
      style={{
        transformOrigin: "256.79px 345.715px 0px",
      }}
      className="animable animator-active"
    >
      <path
        id="freepik--Shadow--inject-102"
        d="M310.17,466l155-89.46c2.44-1.41,2.44-3.7,0-5.11l-252.9-146a9.81,9.81,0,0,0-8.86,0l-155,89.47c-2.44,1.41-2.44,3.7,0,5.11L301.31,466A9.81,9.81,0,0,0,310.17,466Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "256.79px 345.715px 0px",
        }}
        className="animable"
      />
      <ellipse
        id="freepik--shadow--inject-102"
        cx={170.27}
        cy={408.03}
        rx={45.78}
        ry={26.43}
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "170.27px 408.03px 0px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Plants--inject-102"
      style={{
        transformOrigin: "42.8667px 272.284px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--plants--inject-102"
        style={{
          transformOrigin: "42.8667px 272.284px 0px",
        }}
        className="animable"
      >
        <path
          d="M64.75,297.41l6.45-5.6s.84-18.8-4-34.63c-6.83-22.26-23.44-27.91-28.75-24.85s-5.67,10,6.36,21.71C51.89,261,61.94,276.26,64.75,297.41Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "53.0918px 264.486px 0px",
          }}
          id="elh5gu6xtr05"
          className="animable"
        />
        <g id="elrag0t3eaivo">
          <g
            style={{
              opacity: 0.15,
              transformOrigin: "53.0918px 264.486px 0px",
            }}
            className="animable"
          >
            <path
              d="M64.75,297.41l6.45-5.6s.84-18.8-4-34.63c-6.83-22.26-23.44-27.91-28.75-24.85s-5.67,10,6.36,21.71C51.89,261,61.94,276.26,64.75,297.41Z"
              id="el6w11knq66ta"
              style={{
                transformOrigin: "53.0918px 264.486px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M68,287.16h-.07a.52.52,0,0,1-.54-.49C66.24,265,53.29,243.45,42,235.94a.51.51,0,0,1-.15-.71.53.53,0,0,1,.72-.14c11.55,7.64,24.73,29.52,25.88,51.54A.52.52,0,0,1,68,287.16Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "55.1079px 261.083px 0px",
          }}
          id="ele25nvc7pn64"
          className="animable"
        />
        <path
          d="M57.35,312.05c-.58,1.18-4.66.93-5.74.94a10.92,10.92,0,0,1-5.32-1.4,10.05,10.05,0,0,1-4.18-4.54,21.78,21.78,0,0,1-1.19-3.12c-.35-1-.69-2.08-1-3.11a7.87,7.87,0,0,0-1.41-2.89c-1.44-1.63-3.87-1.8-6-1.9-2.4-.11-5.13-.55-6.58-2.7a9.19,9.19,0,0,1-1.17-5.79c.14-2,.57-4,.57-6a6.43,6.43,0,0,0-1.19-4.07,6.51,6.51,0,0,0-2.15-1.59,35.8,35.8,0,0,1-5.12-2.63c-1.55-1.15-2.74-3.06-2.3-4.94a5.94,5.94,0,0,1,3.06-3.43,10.26,10.26,0,0,1,4.26-1.13c4.7-.42,9.39,2.29,14,1.28a41.25,41.25,0,0,0,5.1-1.91,6.54,6.54,0,0,1,5.29,0c3.14,1.75,2.9,6.69,5.75,8.87,2.52,1.93,5.59,1.23,8.47,2.55a6.47,6.47,0,0,1,2.86,2.83,18.85,18.85,0,0,1,2.37,6.44,58.19,58.19,0,0,1,.52,7.23Z"
          style={{
            fill: "rgb(186, 104, 200)",
            transformOrigin: "40.3638px 287.783px 0px",
          }}
          id="eld8i6e5r23ii"
          className="animable"
        />
        <path
          d="M62.81,300.5h0a.51.51,0,0,1-.71-.16c-10.77-17.32-31.37-30.51-40.82-32a.5.5,0,0,1-.42-.58.51.51,0,0,1,.58-.43C31.07,268.85,52,282.24,63,299.81A.51.51,0,0,1,62.81,300.5Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "41.9587px 283.953px 0px",
          }}
          id="elzb63m6szhfo"
          className="animable"
        />
        <path
          d="M46.09,281.76a.42.42,0,0,1-.14.06,69,69,0,0,0-13.57,6.36.51.51,0,0,1-.7-.17.5.5,0,0,1,.16-.71,70.34,70.34,0,0,1,13.81-6.46.51.51,0,0,1,.64.34A.52.52,0,0,1,46.09,281.76Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "38.9538px 284.536px 0px",
          }}
          id="elh3oc78krdt8"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Nightstand--inject-102"
      style={{
        transformOrigin: "295.12px 149.555px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--nightstand--inject-102"
        style={{
          transformOrigin: "295.12px 149.555px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--nightstand--inject-102"
          style={{
            transformOrigin: "295.12px 179.435px 0px",
          }}
          className="animable"
        >
          <polygon
            points="337.5 217.95 329.25 213.19 337.5 210.81 337.5 217.95"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "333.375px 214.38px 0px",
            }}
            id="el24gynwihkwa"
            className="animable"
          />
          <g id="elbx4o6wl2v57">
            <polygon
              points="337.5 217.95 329.25 213.19 337.5 210.81 337.5 217.95"
              style={{
                opacity: 0.6,
                transformOrigin: "333.375px 214.38px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="296.18 234.67 296.18 242.26 248.62 214.74 248.62 207.15 296.18 234.67"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "272.4px 224.705px 0px",
            }}
            id="elos0kmfzne0o"
            className="animable"
          />
          <g id="elv6mgqp93dk">
            <polygon
              points="296.18 234.67 296.18 242.26 248.62 214.74 248.62 207.15 296.18 234.67"
              style={{
                opacity: 0.6,
                transformOrigin: "272.4px 224.705px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="244.49 147.61 292.05 175.13 292.05 237.05 244.49 209.53 244.49 147.61"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "268.27px 192.33px 0px",
            }}
            id="elpz2z78o0y5"
            className="animable"
          />
          <g id="elis36mnw56j">
            <polygon
              points="244.49 147.61 292.05 175.13 292.05 237.05 244.49 209.53 244.49 147.61"
              style={{
                opacity: 0.55,
                transformOrigin: "268.27px 192.33px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="292.05 175.13 345.75 144.13 345.75 206.05 292.05 237.05 292.05 175.13"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "318.9px 190.59px 0px",
            }}
            id="elyiakb5golcc"
            className="animable"
          />
          <g id="elr4sopx71x4m">
            <polygon
              points="292.05 175.13 345.75 144.13 345.75 206.05 292.05 237.05 292.05 175.13"
              style={{
                opacity: 0.45,
                transformOrigin: "318.9px 190.59px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="345.75 144.13 298.18 116.61 244.49 147.61 292.05 175.13 345.75 144.13"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "295.12px 145.87px 0px",
            }}
            id="elq3rcscalxgn"
            className="animable"
          />
          <g id="elfj2d6p0qdp7">
            <polygon
              points="345.75 144.13 298.18 116.61 244.49 147.61 292.05 175.13 345.75 144.13"
              style={{
                opacity: 0.3,
                transformOrigin: "295.12px 145.87px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="296.18 177.51 341.62 151.27 341.62 165.56 296.18 191.8 296.18 177.51"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "318.9px 171.535px 0px",
            }}
            id="el9iewjys106m"
            className="animable"
          />
          <g id="elvf99lm5qc">
            <polygon
              points="296.18 177.51 341.62 151.27 341.62 165.56 296.18 191.8 296.18 177.51"
              style={{
                opacity: 0.2,
                transformOrigin: "318.9px 171.535px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elx6lx3w3k60m">
            <polygon
              points="296.18 196.56 341.62 170.32 341.62 203.66 296.18 229.91 296.18 196.56"
              style={{
                opacity: 0.2,
                transformOrigin: "318.9px 200.115px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="296.18 242.26 300.3 239.88 300.3 232.29 296.18 234.67 296.18 242.26"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "298.24px 237.275px 0px",
            }}
            id="el10sipezwu4tm"
            className="animable"
          />
          <g id="elnjrg226o9ri">
            <polygon
              points="296.18 242.26 300.3 239.88 300.3 232.29 296.18 234.67 296.18 242.26"
              style={{
                opacity: 0.55,
                transformOrigin: "298.24px 237.275px 0px",
              }}
              className="animable"
            />
          </g>
          <polygon
            points="337.5 217.95 341.62 215.57 341.62 208.43 337.5 210.81 337.5 217.95"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "339.56px 213.19px 0px",
            }}
            id="el9ey5rcq7kok"
            className="animable"
          />
          <g id="elt3xthd4tn1m">
            <polygon
              points="337.5 217.95 341.62 215.57 341.62 208.43 337.5 210.81 337.5 217.95"
              style={{
                opacity: 0.55,
                transformOrigin: "339.56px 213.19px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M310.26,172.39c0,.66,2,.05,4.4-1.35l7.7-4.45c2.43-1.4,4.4-3.07,4.4-3.73v-1.19l-16.5,9.53Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "318.51px 167.163px 0px",
            }}
            id="elz46iydaub2"
            className="animable"
          />
          <g id="el3hercijpw1">
            <polygon
              points="341.62 203.66 312.94 186.88 296.18 196.56 296.18 229.91 341.62 203.66"
              style={{
                opacity: 0.2,
                transformOrigin: "318.9px 208.395px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Lamp--inject-102"
          style={{
            transformOrigin: "301.044px 97.7477px 0px",
          }}
          className="animable"
        >
          <path
            d="M311.63,132.64a4,4,0,0,0-.09-.84,12.57,12.57,0,0,0-5.12-7.64H295.71a12.66,12.66,0,0,0-5.12,7.64,3.42,3.42,0,0,0-.08.84c0,.05,0,.15,0,.15.1,1.48,1.12,2.94,3.08,4.07a16.52,16.52,0,0,0,14.94,0c2-1.13,3-2.59,3.07-4.07A1.09,1.09,0,0,0,311.63,132.64Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "301.069px 131.403px 0px",
            }}
            id="elzbb8ylt3rt"
            className="animable"
          />
          <path
            d="M296,124c-2.8,1.62-2.8,4.24,0,5.86a11.23,11.23,0,0,0,10.16,0c2.8-1.62,2.8-4.24,0-5.86A11.23,11.23,0,0,0,296,124Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "301.08px 126.93px 0px",
            }}
            id="el263jjkp8z1j"
            className="animable"
          />
          <path
            d="M302.53,88.26h-2.92V125.8h0a.7.7,0,0,0,.42.67,2.27,2.27,0,0,0,2.06,0,.7.7,0,0,0,.42-.67h0Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "301.07px 107.489px 0px",
            }}
            id="eluhfync6si4"
            className="animable"
          />
          <path
            d="M321.9,87h0L312.1,62H290l-9.81,25h0c-1.4,3.91.52,8.14,5.78,11.18,8.31,4.8,21.79,4.8,30.1,0C321.37,95.14,323.3,90.91,321.9,87Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "301.044px 81.89px 0px",
            }}
            id="eluufupduiglg"
            className="animable"
          />
          <g id="elka00p2g5iuq">
            <path
              d="M321.9,87h0L312.1,62H290l-9.81,25h0c-1.4,3.91.52,8.14,5.78,11.18,8.31,4.8,21.79,4.8,30.1,0C321.37,95.14,323.3,90.91,321.9,87Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "301.044px 81.89px 0px",
              }}
              className="animable"
            />
          </g>
          <ellipse
            cx={301.07}
            cy={63.37}
            rx={11.29}
            ry={6.52}
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "301.07px 63.37px 0px",
            }}
            id="eluxlrjao8c6"
            className="animable"
          />
          <g id="elei1cz1drd6i">
            <ellipse
              cx={301.07}
              cy={63.37}
              rx={11.29}
              ry={6.52}
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.7,
                transformOrigin: "301.07px 63.37px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M301.07,68.28a14.05,14.05,0,0,1-6.92-1.64c-1.61-.93-2.5-2.09-2.5-3.28s.89-2.34,2.5-3.27a15.4,15.4,0,0,1,13.83,0c1.62.93,2.5,2.09,2.5,3.27s-.88,2.35-2.5,3.28A14,14,0,0,1,301.07,68.28Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "301.065px 63.367px 0px",
            }}
            id="elzxmumnufemf"
            className="animable"
          />
          <g id="el47cmi9osddr">
            <path
              d="M301.07,68.28a14.05,14.05,0,0,1-6.92-1.64c-1.61-.93-2.5-2.09-2.5-3.28s.89-2.34,2.5-3.27a15.4,15.4,0,0,1,13.83,0c1.62.93,2.5,2.09,2.5,3.27s-.88,2.35-2.5,3.28A14,14,0,0,1,301.07,68.28Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "301.065px 63.367px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elga3zfdogc5">
            <path
              d="M301.07,68.28a14.05,14.05,0,0,1-6.92-1.64c-1.61-.93-2.5-2.09-2.5-3.28s.89-2.34,2.5-3.27a15.4,15.4,0,0,1,13.83,0c1.62.93,2.5,2.09,2.5,3.27s-.88,2.35-2.5,3.28A14,14,0,0,1,301.07,68.28Z"
              style={{
                opacity: 0.2,
                transformOrigin: "301.065px 63.367px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Coffee--inject-102"
          style={{
            transformOrigin: "268.518px 129.885px 0px",
          }}
          className="animable"
        >
          <g id="elxsj4k9ebn4c">
            <path
              d="M280.7,149.63c0,2.61-4,4.73-8.91,4.73s-8.9-2.12-8.9-4.73,4-4.73,8.9-4.73S280.7,147,280.7,149.63Z"
              style={{
                opacity: 0.1,
                transformOrigin: "271.795px 149.63px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M262.16,134.48c-3.48,0-6.71,0-7.08,2.15s1,8.66,2.93,10.33,6.48,1,6.48,1v-2.12a13.47,13.47,0,0,1-4.4-.34c-1.52-.56-2.59-7.08-2.59-7.84s5-.6,5-.6Z"
            style={{
              fill: "rgb(230, 230, 230)",
              transformOrigin: "259.755px 141.286px 0px",
            }}
            id="elwgihjupxrg"
            className="animable"
          />
          <path
            d="M261.82,131.18c.23-1,1.19-1.9,2.89-2.63a20.29,20.29,0,0,1,14.18,0c1.7.74,2.65,1.67,2.88,2.64h.06c.66,6.33-.48,13.67-2.74,17.73a.59.59,0,0,1,0,.08l0,.07h0a4.89,4.89,0,0,1-1.85,1.74,11.89,11.89,0,0,1-10.76,0,4.84,4.84,0,0,1-1.85-1.75h0l0-.05,0-.1c-2.25-4.06-3.37-11.4-2.7-17.73Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "271.877px 139.684px 0px",
            }}
            id="eld5hvsyjcwiv"
            className="animable"
          />
          <path
            d="M264.71,128.55c-3.92,1.7-3.92,4.45,0,6.16a20.38,20.38,0,0,0,14.19,0c3.92-1.7,3.92-4.46,0-6.16A20.29,20.29,0,0,0,264.71,128.55Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "271.805px 131.627px 0px",
            }}
            id="elyu6mbb78i6"
            className="animable"
          />
          <path
            d="M266.08,129.62c-3.16,1.11-3.17,2.91,0,4a20,20,0,0,0,11.45,0c3.16-1.11,3.16-2.91,0-4A20,20,0,0,0,266.08,129.62Z"
            style={{
              fill: "rgb(230, 230, 230)",
              transformOrigin: "271.803px 131.62px 0px",
            }}
            id="ely0yaja93cgn"
            className="animable"
          />
          <path
            d="M266.07,132.05a6.25,6.25,0,0,0-1.58.79,5.93,5.93,0,0,0,1.58.8,20,20,0,0,0,11.45,0,5.94,5.94,0,0,0,1.58-.79,5.78,5.78,0,0,0-1.58-.8A20,20,0,0,0,266.07,132.05Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "271.795px 132.845px 0px",
            }}
            id="elngsc1vb9lfr"
            className="animable"
          />
          <path
            d="M270.26,125.89c-3.15-2.44-4.85-6.54-2.83-10.63s5.87-6.85,3.94-9.85c0,0,4.35,2.19,3.27,6.56C273.2,117.76,268.34,118.72,270.26,125.89Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "270.684px 115.65px 0px",
            }}
            id="elow3vgj6i8a"
            className="animable"
          />
          <path
            d="M272.58,125.89s-1-3.71.68-6.17,4-3.82,4.06-6.62c0,0,2.37,2.85.72,6S273.21,122.55,272.58,125.89Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "275.454px 119.495px 0px",
            }}
            id="el0078zpgjvlbun"
            className="animable"
          />
        </g>
        <g
          id="freepik--Pills--inject-102"
          style={{
            transformOrigin: "287.078px 162.375px 0px",
          }}
          className="animable"
        >
          <path
            d="M288,159.38l-.06-.14a.41.41,0,0,0-.07-.11,1.46,1.46,0,0,0-.43-.43v.44l-.37-.22v-.44a4.25,4.25,0,0,0-3.59.11,1.54,1.54,0,0,0-.74.79.24.24,0,0,1,0,.08.82.82,0,0,0,0,.22v.87a1,1,0,0,0,.19.59,1.89,1.89,0,0,0,.59.51,4.19,4.19,0,0,0,3.78,0,1.34,1.34,0,0,0,.79-1.1v-.87A1,1,0,0,0,288,159.38Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "285.411px 160.118px 0px",
            }}
            id="elc39lo5173cv"
            className="animable"
          />
          <path
            d="M286.19,158.21a4.19,4.19,0,0,0-2.73.38,1.54,1.54,0,0,0-.74.79.24.24,0,0,1,0,.08.82.82,0,0,0,0,.22v.87a1,1,0,0,0,.19.59,1.89,1.89,0,0,0,.59.51,4.19,4.19,0,0,0,2.73.37Z"
            style={{
              fill: "rgb(230, 230, 230)",
              transformOrigin: "284.471px 160.116px 0px",
            }}
            id="elts24xdsdng"
            className="animable"
          />
          <path
            d="M283.46,158.59c-1,.56-1,1.46-.18,2.07l3.77-2.18A4.25,4.25,0,0,0,283.46,158.59Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "284.868px 159.398px 0px",
            }}
            id="eljb22gbm3bar"
            className="animable"
          />
          <path
            d="M283.28,160.43s-1-.8.12-1.8a1.11,1.11,0,0,0-.12,2l3.77-2.18Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "284.879px 159.54px 0px",
            }}
            id="eljorha5xbjnl"
            className="animable"
          />
          <path
            d="M287.42,158.7l-3.76,2.18a4.23,4.23,0,0,0,3.58-.11C288.23,160.21,288.29,159.31,287.42,158.7Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "285.845px 159.962px 0px",
            }}
            id="eluod5w3hn42g"
            className="animable"
          />
          <path
            d="M283.66,160.88a4.23,4.23,0,0,0,3.58-.11,1.86,1.86,0,0,0,.31-.21,4.32,4.32,0,0,1-3.47.28l3.34-2.14Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "285.605px 159.962px 0px",
            }}
            id="eli4sejck3bx"
            className="animable"
          />
          <polygon
            points="287.05 158.92 283.28 161.11 283.28 160.66 287.05 158.48 287.05 158.92"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "285.165px 159.795px 0px",
            }}
            id="elmbxf9xnbq1d"
            className="animable"
          />
          <g id="elpyqu7tx9o6">
            <polygon
              points="283.66 160.88 283.66 161.32 283.28 161.11 283.66 160.88"
              style={{
                opacity: 0.2,
                transformOrigin: "283.47px 161.1px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M291.37,163.89l-.07-.14a.39.39,0,0,0-.06-.11,1.59,1.59,0,0,0-.43-.43v.44l-.38-.22V163a4.23,4.23,0,0,0-3.58.11,1.5,1.5,0,0,0-.74.79s0,.05,0,.08a.83.83,0,0,0,0,.22v.88a1,1,0,0,0,.2.58,1.78,1.78,0,0,0,.59.51,4.19,4.19,0,0,0,3.78,0,1.35,1.35,0,0,0,.79-1.09v-.88A1,1,0,0,0,291.37,163.89Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "288.786px 164.638px 0px",
            }}
            id="elurh1ygio209"
            className="animable"
          />
          <path
            d="M289.58,162.72a4.19,4.19,0,0,0-2.73.38,1.5,1.5,0,0,0-.74.79s0,.05,0,.08a.83.83,0,0,0,0,.22v.88a1,1,0,0,0,.2.58,1.78,1.78,0,0,0,.59.51,4.19,4.19,0,0,0,2.73.37Z"
            style={{
              fill: "rgb(230, 230, 230)",
              transformOrigin: "287.866px 164.626px 0px",
            }}
            id="elig79lzjn1c8"
            className="animable"
          />
          <path
            d="M286.85,163.1c-1,.56-1,1.46-.18,2.07l3.76-2.18A4.23,4.23,0,0,0,286.85,163.1Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "288.253px 163.908px 0px",
            }}
            id="elzp075iwwnl"
            className="animable"
          />
          <path
            d="M286.67,164.94s-1-.8.11-1.8a1.11,1.11,0,0,0-.11,2l3.76-2.18Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "288.261px 164.05px 0px",
            }}
            id="elu6tpiqexpeb"
            className="animable"
          />
          <path
            d="M290.81,163.21l-3.76,2.18a4.23,4.23,0,0,0,3.58-.11C291.61,164.72,291.67,163.82,290.81,163.21Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "289.231px 164.472px 0px",
            }}
            id="elynksbt5e55p"
            className="animable"
          />
          <path
            d="M287.05,165.39a4.23,4.23,0,0,0,3.58-.11,1.86,1.86,0,0,0,.31-.21,4.32,4.32,0,0,1-3.47.28l3.34-2.14Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "288.995px 164.472px 0px",
            }}
            id="elqp21qji5i9r"
            className="animable"
          />
          <polygon
            points="290.43 163.43 286.67 165.62 286.67 165.17 290.43 162.99 290.43 163.43"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "288.55px 164.305px 0px",
            }}
            id="el8uhbo0q4z7d"
            className="animable"
          />
          <g id="elu149lmjx6u">
            <polygon
              points="287.05 165.39 287.05 165.84 286.67 165.62 287.05 165.39"
              style={{
                opacity: 0.2,
                transformOrigin: "286.86px 165.615px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--pill-bottle--inject-102"
          style={{
            transformOrigin: "301.43px 152.292px 0px",
          }}
          className="animable"
        >
          <g id="el5ov0vq9u9iw">
            <path
              d="M306.63,162.13a11.48,11.48,0,0,1-10.4,0c-2.87-1.66-2.87-4.35,0-6a11.48,11.48,0,0,1,10.4,0C309.5,157.78,309.5,160.47,306.63,162.13Z"
              style={{
                opacity: 0.1,
                transformOrigin: "301.43px 159.13px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M295.39,148a3.14,3.14,0,0,1,1.85-2.58,9.87,9.87,0,0,1,8.95,0A3.14,3.14,0,0,1,308,148h0v10.75h0a3.14,3.14,0,0,1-1.85,2.58,9.87,9.87,0,0,1-8.95,0,3.14,3.14,0,0,1-1.85-2.58h0Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "301.675px 153.375px 0px",
            }}
            id="eltr9plrt5g3r"
            className="animable"
          />
          <g id="elsrwm4b2k1x">
            <path
              d="M297.82,145.09V161.6c-.2-.1-.39-.19-.58-.3a4.77,4.77,0,0,1-1-.76V146.15a4.77,4.77,0,0,1,1-.76A6.36,6.36,0,0,1,297.82,145.09Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "297.03px 153.345px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elgvnea34gxnt">
            <path
              d="M299.48,162.13a6.78,6.78,0,0,1-.91-.25V144.81a6.78,6.78,0,0,1,.91-.25Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "299.025px 153.345px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el925gd4l3xtq">
            <path
              d="M295.5,147.3A4.47,4.47,0,0,1,297,146a10.57,10.57,0,0,1,8.92-.29v-.5l.3.16A3.14,3.14,0,0,1,308,148v2.47h0v4.74h0v3.54a3.14,3.14,0,0,1-1.85,2.58,9.87,9.87,0,0,1-8.95,0,4.52,4.52,0,0,1-1.13-.88c1.18,1.1,4.11,1.7,6.28,1.28s3.5-1.82,3.5-2.81v-.95a9.47,9.47,0,0,1-4.38,1v-4.82a9.45,9.45,0,0,0,4.38-.9v-1.4a10.61,10.61,0,0,1-8.92-.3,4.18,4.18,0,0,1-1.58-1.46V148A2.19,2.19,0,0,1,295.5,147.3Z"
              style={{
                opacity: 0.1,
                transformOrigin: "301.675px 153.632px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elyscqk3h6syj">
            <path
              d="M307,159.17V145.94a2.71,2.71,0,0,1,1.07,2v10.75a3.14,3.14,0,0,1-1.85,2.58,7.93,7.93,0,0,1-2.41.87C306.16,161.52,307,159.9,307,159.17Z"
              style={{
                opacity: 0.1,
                transformOrigin: "305.94px 154.04px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M295,145.08a3.33,3.33,0,0,1,2-2.74,10.51,10.51,0,0,1,9.49,0,3.33,3.33,0,0,1,2,2.74h0v3h0a3.31,3.31,0,0,1-2,2.74,10.51,10.51,0,0,1-9.49,0,3.31,3.31,0,0,1-2-2.74h0v-3Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "301.745px 146.58px 0px",
            }}
            id="elolq97kjl1je"
            className="animable"
          />
          <g
            style={{
              clipPath: "url(&quot",
              transformOrigin: "301.715px 148.185px 0px",
            }}
            id="elfejf9xvp418"
            className="animable"
          >
            <g id="elant3kr6u1cv">
              <g
                style={{
                  opacity: 0.2,
                  transformOrigin: "301.715px 148.64px 0px",
                }}
                className="animable"
              >
                <rect
                  x={294.85}
                  y={144.81}
                  width={0.32}
                  height={4.62}
                  id="el2jxlmr0t3n6"
                  style={{
                    transformOrigin: "295.01px 147.12px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={295.59}
                  y={146.05}
                  width={0.32}
                  height={4.65}
                  id="el03tzzo8bl4rg"
                  style={{
                    transformOrigin: "295.75px 148.375px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={296.7}
                  y={146.91}
                  width={0.32}
                  height={4.67}
                  id="elosy9cnflq7l"
                  style={{
                    transformOrigin: "296.86px 149.245px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={297.98}
                  y={147.45}
                  width={0.32}
                  height={4.7}
                  id="eldiq2vw06zeb"
                  style={{
                    transformOrigin: "298.14px 149.8px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={299.39}
                  y={147.8}
                  width={0.32}
                  height={4.72}
                  id="el6mtkuo76yz3"
                  style={{
                    transformOrigin: "299.55px 150.16px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={300.87}
                  y={147.98}
                  width={0.32}
                  height={4.75}
                  id="elwyczqc8gbdp"
                  style={{
                    transformOrigin: "301.03px 150.355px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={302.38}
                  y={147.98}
                  width={0.32}
                  height={4.77}
                  id="el0qunkdq73rf"
                  style={{
                    transformOrigin: "302.54px 150.365px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={303.86}
                  y={147.78}
                  width={0.32}
                  height={4.8}
                  id="el2s1as4dz2jj"
                  style={{
                    transformOrigin: "304.02px 150.18px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={305.24}
                  y={147.38}
                  width={0.32}
                  height={4.82}
                  id="el991l2hs3x6e"
                  style={{
                    transformOrigin: "305.4px 149.79px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={306.49}
                  y={146.77}
                  width={0.32}
                  height={4.85}
                  id="elwluprcinei"
                  style={{
                    transformOrigin: "306.65px 149.195px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={307.48}
                  y={145.91}
                  width={0.32}
                  height={4.87}
                  id="elcm1ybftr554"
                  style={{
                    transformOrigin: "307.64px 148.345px 0px",
                  }}
                  className="animable"
                />
                <rect
                  x={308.26}
                  y={144.53}
                  width={0.32}
                  height={4.9}
                  id="elythbgp5drn"
                  style={{
                    transformOrigin: "308.42px 146.98px 0px",
                  }}
                  className="animable"
                />
              </g>
            </g>
            <g id="elk4gd8ttpfb">
              <path
                d="M300.11,151.81c3.32,0,5.07-1.06,5.6-1.94a6.82,6.82,0,0,0,.48-3.13s.37-2.79.3-2.79.79-.19,1.44-.33a2.51,2.51,0,0,1,.49,1.46h0v3h0a3.31,3.31,0,0,1-2,2.74A10.31,10.31,0,0,1,300.11,151.81Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "304.265px 147.78px 0px",
                }}
                className="animable"
              />
            </g>
          </g>
          <path
            d="M306.46,147.82a10.51,10.51,0,0,1-9.49,0c-2.62-1.51-2.62-4,0-5.48a10.51,10.51,0,0,1,9.49,0C309.08,143.85,309.08,146.31,306.46,147.82Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "301.715px 145.08px 0px",
            }}
            id="el62c61tj9wyg"
            className="animable"
          />
          <path
            d="M296.61,147.59c-2.25-1.52-2.13-3.81.36-5.25a9.62,9.62,0,0,1,4.61-1.13,7.25,7.25,0,0,1,2.45.84c2.27,1.29,2.27,3.87,0,5.17A9.28,9.28,0,0,1,296.61,147.59Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "300.37px 144.701px 0px",
            }}
            id="el3ffg0jhke6q"
            className="animable"
          />
          <g id="elfe25bx8lhrq">
            <path
              d="M305.82,161a10.28,10.28,0,0,1-8.21,0c-2.27-1.14-2.27-3,0-4.12a10.28,10.28,0,0,1,8.21,0C308.09,158,308.09,159.87,305.82,161Z"
              style={{
                opacity: 0.1,
                transformOrigin: "301.715px 158.94px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M308,150.75a3.16,3.16,0,0,1-1.85,2.59,9.21,9.21,0,0,1-4.48,1.06v4.74a9.21,9.21,0,0,0,4.48-1.06,3.16,3.16,0,0,0,1.85-2.59Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "304.835px 154.946px 0px",
            }}
            id="el8mekt0j9zxq"
            className="animable"
          />
          <path
            d="M307.91,146.57a9,9,0,0,1-6.4,2.08c-4.21-.12-5.9-2.42-6.12-3.13a2.65,2.65,0,0,1,.57-2.43,2.76,2.76,0,0,0-.95,2v3c0,.25-.13,1.12,1.23,2.24a3.31,3.31,0,0,1-.8-1.78v-2s1.49,2.49,6.07,2.49S307.68,146.94,307.91,146.57Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "301.458px 146.71px 0px",
            }}
            id="el378imh09r0b"
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Slippers--inject-102"
      style={{
        transformOrigin: "169.232px 407.011px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--slippers--inject-102"
        style={{
          transformOrigin: "169.232px 407.011px 0px",
        }}
        className="animable"
      >
        <path
          d="M138,404.13a11,11,0,0,0,0,3.53c.73,2.27,4.36,5.37,10,5.9,5.21.49,9.85-.64,13.36-3.22s8.62-7.48,11.39-9.68c3.3-2.63,6-4.94,6.67-6s.24-3.61.24-3.61Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "158.827px 402.361px 0px",
          }}
          id="el7jgdy675t7c"
          className="animable"
        />
        <path
          d="M160.71,408.5c3.39-2.86,12.68-10.34,15.85-13.12s4.72-5.09.72-7.3a13.51,13.51,0,0,0-14,.74c-4.37,3.07-21.46,14.59-21.46,14.59Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "160.747px 397.487px 0px",
          }}
          id="el5cyayzsl7am"
          className="animable"
        />
        <path
          d="M146.65,396c5.14.07,8.15,1.9,11.46,5.25a8.7,8.7,0,0,1,2.6,7.24,17.64,17.64,0,0,1-14,2.74c-7.68-1.64-8.77-6.53-8.77-6.53S138.74,397.14,146.65,396Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "149.353px 403.833px 0px",
          }}
          id="elpsjfh5xjooh"
          className="animable"
        />
        <path
          d="M158.82,418a11,11,0,0,0,0,3.54c.74,2.27,4.37,5.37,10,5.9,5.2.48,9.85-.65,13.36-3.22s8.61-7.48,11.38-9.69c3.31-2.62,6-4.94,6.67-6s.24-3.61.24-3.61Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "179.641px 416.234px 0px",
          }}
          id="elxnojvf43ps"
          className="animable"
        />
        <path
          d="M181.55,422.36c3.39-2.86,12.68-10.34,15.85-13.12s4.72-5.09.71-7.31a13.52,13.52,0,0,0-14,.75c-4.36,3.06-21.46,14.58-21.46,14.58Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "181.581px 411.345px 0px",
          }}
          id="el75qvumdwts6"
          className="animable"
        />
        <path
          d="M167.48,409.86c5.14.08,8.16,1.91,11.47,5.25a8.72,8.72,0,0,1,2.6,7.25,17.65,17.65,0,0,1-14,2.73c-7.69-1.63-8.78-6.53-8.78-6.53S159.58,411,167.48,409.86Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "170.188px 417.694px 0px",
          }}
          id="elvf4m917sbo"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Character--inject-102"
      style={{
        transformOrigin: "258.615px 283.845px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--character-on-the-bed--inject-102"
        style={{
          transformOrigin: "258.615px 283.845px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--Bed--inject-102"
          style={{
            transformOrigin: "258.615px 290.655px 0px",
          }}
          className="animable"
        >
          <path
            d="M66,318.05l-6-3.47a6.94,6.94,0,0,1-3.14-5.43V215.49A6.94,6.94,0,0,1,60,210.07L203.78,127a6.91,6.91,0,0,1,6.26,0l6.06,3.47a6.91,6.91,0,0,1,3.13,5.42v93.66A6.93,6.93,0,0,1,216.1,235L72.26,318.05A7,7,0,0,1,66,318.05Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "138.045px 222.52px 0px",
            }}
            id="el7aubuo9pqiy"
            className="animable"
          />
          <g id="eljtu3qts00v">
            <path
              d="M66,318.05l-6-3.47a6.94,6.94,0,0,1-3.14-5.43V215.49A6.94,6.94,0,0,1,60,210.07L203.78,127a6.91,6.91,0,0,1,6.26,0l6.06,3.47a6.91,6.91,0,0,1,3.13,5.42v93.66A6.93,6.93,0,0,1,216.1,235L72.26,318.05A7,7,0,0,1,66,318.05Z"
              style={{
                opacity: 0.3,
                transformOrigin: "138.045px 222.52px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M219.23,135.89v93.66A6.93,6.93,0,0,1,216.1,235L72.26,318.05c-1.73,1-3.13.18-3.13-1.81V222.58a6.93,6.93,0,0,1,3.13-5.43L216.1,134.08C217.83,133.08,219.23,133.89,219.23,135.89Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "144.18px 226.064px 0px",
            }}
            id="el4c9g2t4cmrs"
            className="animable"
          />
          <g id="el0vn4k17mkpcr">
            <path
              d="M219.23,135.89v93.66A6.93,6.93,0,0,1,216.1,235L72.26,318.05c-1.73,1-3.13.18-3.13-1.81V222.58a6.93,6.93,0,0,1,3.13-5.43L216.1,134.08C217.83,133.08,219.23,133.89,219.23,135.89Z"
              style={{
                opacity: 0.45,
                transformOrigin: "144.18px 226.064px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M71.54,318.38A7,7,0,0,1,66,318l-6.06-3.46a6.94,6.94,0,0,1-3.12-5.43V215.49a6.32,6.32,0,0,1,.91-3.08l12.32,7.08a6.32,6.32,0,0,0-.91,3.08v93.66C69.14,317.94,70.16,318.78,71.54,318.38Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "64.18px 265.595px 0px",
            }}
            id="elj965l17a5f"
            className="animable"
          />
          <g id="el1i1hld8qmpd">
            <path
              d="M71.54,318.38A7,7,0,0,1,66,318l-6.06-3.46a6.94,6.94,0,0,1-3.12-5.43V215.49a6.32,6.32,0,0,1,.91-3.08l12.32,7.08a6.32,6.32,0,0,0-.91,3.08v93.66C69.14,317.94,70.16,318.78,71.54,318.38Z"
              style={{
                opacity: 0.55,
                transformOrigin: "64.18px 265.595px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M320.3,417.36,305.8,409a3.45,3.45,0,0,0-3.13,0l-14.5,8.37a3.13,3.13,0,0,0-1.11,1.17h0a1.85,1.85,0,0,0-.13.29,3,3,0,0,0-.33,1.25V443.6h0a3.46,3.46,0,0,0,1.45,2.62.94.94,0,0,0,.12.09l14.5,8.38h0c.05,0,.13,0,.18.07a3.29,3.29,0,0,0,.55.21,3.84,3.84,0,0,0,.83.09,3.31,3.31,0,0,0,1.57-.37l14.5-8.38a3.47,3.47,0,0,0,1.57-2.71V420.07A3.47,3.47,0,0,0,320.3,417.36Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "304.235px 431.842px 0px",
            }}
            id="el8jegoa5obbn"
            className="animable"
          />
          <path
            d="M305.8,454.69l14.5-8.38a3.47,3.47,0,0,0,1.57-2.71V420.07c0-1-.71-1.4-1.57-.9l-14.5,8.37a3.47,3.47,0,0,0-1.57,2.71v23.53C304.23,454.78,304.93,455.18,305.8,454.69Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "313.05px 436.927px 0px",
            }}
            id="el6ec2j6n49fj"
            className="animable"
          />
          <path
            d="M452.94,340.74l-14.5-8.37a3.45,3.45,0,0,0-3.13,0l-14.51,8.37a3.19,3.19,0,0,0-1.1,1.17h0a1.6,1.6,0,0,0-.13.3,2.91,2.91,0,0,0-.33,1.24v24.66h0a3.46,3.46,0,0,0,1.45,2.62.87.87,0,0,0,.11.09l14.51,7.25h0c.05,0,.12,0,.18.07a3.29,3.29,0,0,0,.55.21,3.84,3.84,0,0,0,.83.09,3.2,3.2,0,0,0,1.57-.37l14.5-8.38A3.46,3.46,0,0,0,454.5,367V343.45A3.47,3.47,0,0,0,452.94,340.74Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "436.87px 355.218px 0px",
            }}
            id="el3y741jqncy8"
            className="animable"
          />
          <path
            d="M438.44,378.07l14.5-8.38A3.46,3.46,0,0,0,454.5,367V343.45c0-1-.71-1.4-1.57-.9l-14.5,8.37a3.47,3.47,0,0,0-1.57,2.71v23.53C436.87,378.16,437.57,378.57,438.44,378.07Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "445.68px 360.309px 0px",
            }}
            id="elprh0prjtw7h"
            className="animable"
          />
          <path
            d="M219,199.29l-143.61,83a13.83,13.83,0,0,0-6.27,10.85v5.95A13.86,13.86,0,0,0,75.4,309.9L298,438.4a13.83,13.83,0,0,0,12.53,0l143.62-83a13.85,13.85,0,0,0,6.26-10.85v-5.95a13.85,13.85,0,0,0-6.26-10.85L231.54,199.29A13.83,13.83,0,0,0,219,199.29Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "264.765px 318.844px 0px",
            }}
            id="elnwee53ilm7"
            className="animable"
          />
          <path
            d="M460.38,338.65v5.94a13.82,13.82,0,0,1-6.26,10.85l-143.62,83a12.79,12.79,0,0,1-6.26,1.49V419.48A12.79,12.79,0,0,0,310.5,418l143.62-83c3.22-1.88,3.44-4.82.63-6.83A14,14,0,0,1,460.38,338.65Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "382.31px 384.051px 0px",
            }}
            id="elyy727tsyzko"
            className="animable"
          />
          <path
            d="M75.4,289.49c-3.29-1.9-3.45-4.92-.48-6.91a13.92,13.92,0,0,0-5.79,10.52v5.95A13.86,13.86,0,0,0,75.4,309.9L298,438.4a12.81,12.81,0,0,0,6.27,1.5V419.48A12.8,12.8,0,0,1,298,418Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "186.7px 361.241px 0px",
            }}
            id="elxst8to6lhx"
            className="animable"
          />
          <path
            d="M219,165.41l-143.61,83a13.86,13.86,0,0,0-6.27,10.85V271.9a13.86,13.86,0,0,0,6.27,10.85L298,411.25a13.83,13.83,0,0,0,12.53,0l143.62-83a13.82,13.82,0,0,0,6.26-10.85V304.76a13.85,13.85,0,0,0-6.26-10.85L231.54,165.41A13.83,13.83,0,0,0,219,165.41Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "264.765px 288.329px 0px",
            }}
            id="ell9ktwjhclw8"
            className="animable"
          />
          <g id="eljdcrqtfxoh9">
            <path
              d="M75.39,255.61,298,384.11a13.83,13.83,0,0,0,12.53,0l143.62-82.95c3.46-2,3.46-5.24,0-7.24L231.54,165.42a13.83,13.83,0,0,0-12.53,0l-143.62,83C71.93,250.38,71.93,253.62,75.39,255.61Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.8,
                transformOrigin: "264.77px 274.765px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elr7mmmf287ei">
            <path
              d="M460.38,304.77v12.68a13.85,13.85,0,0,1-6.26,10.85L310.5,411.25a12.8,12.8,0,0,1-6.26,1.5V385.6a12.79,12.79,0,0,0,6.26-1.49l143.62-83c3.22-1.88,3.44-4.82.63-6.83A14,14,0,0,1,460.38,304.77Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.5,
                transformOrigin: "382.31px 353.516px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el79onmam6mc3">
            <path
              d="M75.4,255.61c-3.29-1.9-3.45-4.91-.48-6.91a13.92,13.92,0,0,0-5.79,10.52V271.9a13.86,13.86,0,0,0,6.27,10.85L298,411.25a12.81,12.81,0,0,0,6.27,1.5V385.6a12.8,12.8,0,0,1-6.27-1.49Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.6,
                transformOrigin: "186.7px 330.726px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M253.16,191.7c2-7.44-1-11.33-5.08-18.24s-13.63-20.28-17.54-26-8.26-11.35-10.6-12.14-3.92-1.73-10.11.51-19.05,9.87-35,18.64-22.44,12.81-23.42,21.4c-.61,5.31,27.41,52.07,34.23,52.77,15.15,1.55,16.43-1.33,24.87-6.42,14.08-8.48,24.15-14.75,33.9-21.36C248.86,197.86,252.21,195.15,253.16,191.7Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "202.598px 181.746px 0px",
            }}
            id="el6rj4rkgrjad"
            className="animable"
          />
          <path
            d="M158.81,194.61c3.71,6,14.52,22.34,18.27,27.17s10.27,10.32,11.79,4.13-4.29-14-8.23-20.15-14.94-20.63-18.51-25.36-9.52-9.35-10.92-3.82S155.11,188.59,158.81,194.61Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "170.049px 201.364px 0px",
            }}
            id="elgoz9imzdlj"
            className="animable"
          />
          <path
            d="M182.94,232.83c2-7.44-1-11.33-5.08-18.24s-13.63-20.28-17.54-26-8.26-11.35-10.6-12.14-3.92-1.73-10.11.51-19.05,9.87-35,18.64-27.14,15.48-28.12,24.07c-.61,5.31,27.41,52.08,34.23,52.77,15.15,1.56,21.14-4,29.58-9.09,14.07-8.48,24.14-14.75,33.89-21.36C178.64,239,182,236.28,182.94,232.83Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "130.028px 224.135px 0px",
            }}
            id="el62lh4fqr4yl"
            className="animable"
          />
          <path
            d="M83.9,238.42c3.7,6,14.51,22.33,18.26,27.17s10.27,10.31,11.79,4.12-4.29-14-8.22-20.15-15-20.63-18.52-25.36-9.52-9.35-10.92-3.81S80.19,232.4,83.9,238.42Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "95.129px 245.168px 0px",
            }}
            id="elgelltfgfdo"
            className="animable"
          />
          <path
            d="M176.09,239.8c2.59,9.54,3.69,19.12,16.21,30s71.45,42.05,71.45,42.05l38.38-44.43-57.2-35.46-19.67-8.1Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "239.11px 267.855px 0px",
            }}
            id="el9mvqgoyvto"
            className="animable"
          />
          <path
            d="M139.36,291v47.44l165.62,96V384.86a12.88,12.88,0,0,1-6.26-1.49Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "222.17px 362.72px 0px",
            }}
            id="elelpo1hmi87"
            className="animable"
          />
          <g id="elxhz6uw3z9ic">
            <path
              d="M139.36,291v47.44l165.62,96V384.86a12.88,12.88,0,0,1-6.26-1.49Z"
              style={{
                opacity: 0.3,
                transformOrigin: "222.17px 362.72px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M454.13,300.24c3.22-1.88,3.44-4.81.63-6.82a14,14,0,0,1,5.62,10.44v40.21L305,434.42V384.86a12.89,12.89,0,0,0,6.26-1.49Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "382.69px 363.92px 0px",
            }}
            id="elgbgxfgmadz"
            className="animable"
          />
          <g id="el957f05l9id7">
            <path
              d="M454.13,300.24c3.22-1.88,3.44-4.81.63-6.82a14,14,0,0,1,5.62,10.44v40.21L305,434.42V384.86a12.89,12.89,0,0,0,6.26-1.49Z"
              style={{
                opacity: 0.45,
                transformOrigin: "382.69px 363.92px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M454.13,293,294.76,200.62l-50.24,29.27c-18.12-2.64-51.81,19.47-59.63,34.43L139.36,291l159.36,92.39a13.87,13.87,0,0,0,12.52,0l142.89-83.13C457.58,298.24,457.58,295,454.13,293Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "298.039px 292.752px 0px",
            }}
            id="el8tytz8gndzb"
            className="animable"
          />
          <g id="el0nu8dlt1ahm">
            <path
              d="M454.13,293,294.76,200.62l-50.24,29.27c-18.12-2.64-51.81,19.47-59.63,34.43L139.36,291l159.36,92.39a13.87,13.87,0,0,0,12.52,0l142.89-83.13C457.58,298.24,457.58,295,454.13,293Z"
              style={{
                opacity: 0.2,
                transformOrigin: "298.039px 292.752px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elqjk0z4f7ot">
            <path
              d="M170.31,273.63c4.24,5.47,13.42,8.85,19.86,10.55a49.86,49.86,0,0,0,13,1.66,39,39,0,0,1-2,10.36c-.88,2.57-4.31,6.67-.41,7.9,3,.94,8.21-.54,11.28-1a110.4,110.4,0,0,0,11.65-2.4c2.1-.55,4.33-1.26,5.64-3,1.47-2,1.34-4.64,1.72-7.07.35-2.28,1.69-4.93,4.24-5.17-2.77-1.56-6.85-2.36-9.94-3.4-4.64-1.56-9.34-2.95-14-4.52q-14.18-4.79-28.09-10.32c-.65-.26-1.33-.53-2-.78l-11.32,6.63C170.05,273.26,170.17,273.45,170.31,273.63Z"
              style={{
                opacity: 0.1,
                transformOrigin: "202.615px 285.423px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elkbtj54m454">
            <path
              d="M454.13,293,294.76,200.62l-50.24,29.27c13.65,8.68,27,13.66,40.92,21.66,6.71,3.86,14.49,10.16,31.49,21.76,5.58,3.8,12.25,8.22,19.3,7.52,5.34-.53,10-3.74,15.14-5.32a8.62,8.62,0,0,1,3.44-.5c5.09.53,4.72,6.65,4.8,10.35A28.4,28.4,0,0,1,355,301.5a9,9,0,0,0-1.48,3.4c-.64,3.82,1.24,6.73,4.88,8.33s42.72,17.86,49.68,13.85l46-26.84C457.57,298.25,457.57,295,454.13,293Z"
              style={{
                opacity: 0.1,
                transformOrigin: "350.612px 264.167px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elv1h2hg420l">
            <path
              d="M303.22,327.73q-4.31-2.61-8.49-5.42c-1.09-.73-6-3.95-7.26-5.05,3.63,1.6,7.22,3.26,10.8,4.95,3.93,1.86,7.9,3.63,11.94,5.22,5.43,2.13,14.45,6.15,19.13.43,2.79-3.41,2-8.38,3-12.68s8.42-18.48-1-19.45a8.79,8.79,0,0,0-3.44.49c-5.13,1.59-9.8,4.79-15.14,5.32-7.06.7-14.17-3.13-19.3-7.52a131.12,131.12,0,0,0-19.54-13.38c-.57-.32-.52-.09-1-.54a59,59,0,0,1,8.63,4.14c2.11,1.24,4.13,2.6,6.24,3.83A125.54,125.54,0,0,0,300,294.48a27.27,27.27,0,0,0,13.29,2.62c5.36-.48,10.26-3.08,15.26-5.06a12.53,12.53,0,0,1,6.13-1.21c3.34.43,6.14,4.62,6,7.86,0,.1,0,.2,0,.3-.63,5.47-1.55,10.89-2.06,16.37a8.5,8.5,0,0,0,.51,4.83,6.72,6.72,0,0,0,4.64,3c1.84.42,3.77.49,5.57,1.07a1.19,1.19,0,0,1,.62.37c.28.4,0,.94-.29,1.33a16.65,16.65,0,0,1-6.51,4.8c-2.48,1.14-5.1,1.94-7.61,3a31.74,31.74,0,0,1-6,2.28,22.87,22.87,0,0,1-4.05.3c-2.35,0-6.94,0-14-3.86C308.62,331,305.9,329.36,303.22,327.73Z"
              style={{
                opacity: 0.1,
                transformOrigin: "311.498px 308.221px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el706m78j7j0o">
            <polygon
              points="162.84 304.53 162.84 352.06 165.78 353.67 165.77 306.23 162.84 304.53"
              style={{
                opacity: 0.2,
                transformOrigin: "164.31px 329.1px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elpjzh6fx09ye">
            <path
              d="M162.84,304.53l42-24.61c9.43-11.43,44.62-39.15,64.06-37l49.36-28.77,3.06,1.79-49.14,28.59c-19.47,1-47.55,19-64.23,37l-42.17,24.67Z"
              style={{
                opacity: 0.1,
                transformOrigin: "242.08px 260.175px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--character--inject-102"
          style={{
            transformOrigin: "207.04px 206.776px 0px",
          }}
          className="animable"
        >
          <path
            d="M265,218.19c-4.57,1.51-13.1,1.55-21.16-4.21-9.37-6.69-24.9-18-24.9-18s-16.43-24.93-11.34-25.8a28.12,28.12,0,0,1,21.57,6c6,5.06,33.93,33.11,33.93,33.11Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "235.811px 194.481px 0px",
            }}
            id="elmvbecfbr2v"
            className="animable"
          />
          <path
            d="M218.9,195.93s15.53,11.36,24.9,18c8.06,5.76,16.59,5.72,21.16,4.21l-1.9-9S235.19,181,229.22,176a27.08,27.08,0,0,0-21.72-5.85C202.44,171.14,218.9,195.93,218.9,195.93Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "235.747px 194.391px 0px",
            }}
            id="elgr5j8zoaxxa"
            className="animable"
          />
          <g id="elcu4mws9bc">
            <path
              d="M218.9,195.93s15.53,11.36,24.9,18c8.06,5.76,16.59,5.72,21.16,4.21l-1.9-9S235.19,181,229.22,176a27.08,27.08,0,0,0-21.72-5.85C202.44,171.14,218.9,195.93,218.9,195.93Z"
              style={{
                opacity: 0.1,
                transformOrigin: "235.747px 194.391px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="el17tdot6jrel">
            <path
              d="M230.67,177.51l-13.1-.4-.66,6.7s4.93.56,8.53,1.21a15.45,15.45,0,0,1,9.55,5.57c3,3.45,7.3,11.18,11.54,17.12a30.62,30.62,0,0,0,9.36,8.91l1.42-13.16c-5-5-12.38-12.3-18.48-18.23C238.51,185.33,230.67,177.51,230.67,177.51Z"
              style={{
                opacity: 0.2,
                transformOrigin: "237.11px 196.865px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M231.22,226.28l-7.15-7.88-.85-9.49a15,15,0,0,0,2.69-19.54c-3.91-6.35-6.27-8.3-9.39-11.48-4.85-4.92-7.19-6.95-9-7.76a72.49,72.49,0,0,0-9.13,1.09l-14.75,2.11-11.2,3.07c-2.73,14.19-5,27.31-2.89,42.34,2.85,19.81,5.11,25.79,12.5,38.83,1.24-10.59,19.74-21.58,27.46-25.11C222.76,226.41,231.22,226.28,231.22,226.28Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "199.971px 213.85px 0px",
            }}
            id="elgvlm7b1m4nk"
            className="animable"
          />
          <path
            d="M202.5,113.32,196,114c-6.71.66-13.29,1-19.14,4.72a23.6,23.6,0,0,0-10.24,14.17c-2,8.28,1.21,17.27,6.08,23.26a46.73,46.73,0,0,0,5.52,6.27c2,1.76,3.91,3.22,5.23,3.39l-.34-5.56a19.17,19.17,0,0,0,9.41,1.82l5-.25A16.43,16.43,0,0,0,209.16,156a32.54,32.54,0,0,0,3.94-5.75c.77-1.39.54-2.9,1.16-4.31a37.57,37.57,0,0,1,2.4-4.29,18.9,18.9,0,0,0,2.59-5.87,8.9,8.9,0,0,0-.8-6.35,7.56,7.56,0,0,0-4.43-3c3.8-3.52,4.68-11.12-1-13.34a11.09,11.09,0,0,0-5.1-.29Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "192.763px 139.22px 0px",
            }}
            id="el60oqb01syo3"
            className="animable"
          />
          <path
            d="M207.24,125c3,1.51,8.1,8.46,8.69,23.52.49,12.77-3.45,16.18-5.47,17.22s-6.05.73-10,.32l.11,6.21c6.19,7-4.66,8.38-12.82,5-1.17-.49-4.05-2.93-4.09-3.93L183,157.74a5.36,5.36,0,0,1-6.32-1.15c-2.93-3.23-3.93-8.09-1.59-10.78s6.41-1.84,8.43.79c0,0,2.32-2.41,10.3-7.46S206.09,130.74,207.24,125Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "194.882px 152.017px 0px",
            }}
            id="elzhr4mgnm6ga"
            className="animable"
          />
          <path
            d="M183.47,146.6l.05,6h0a4.28,4.28,0,0,0,4.25-4.32l-.06-7.21Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "185.62px 146.835px 0px",
            }}
            id="elwocun3f9z7o"
            className="animable"
          />
          <path
            d="M212.29,144.32c-.23.94-1,.88-2,.65s-1.66-.55-1.43-1.49a1.76,1.76,0,1,1,3.41.84Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "210.584px 143.569px 0px",
            }}
            id="ele2kho8e0w9"
            className="animable"
          />
          <path
            d="M200,144.75c.38.93-.17,1.34-1.1,1.72s-1.89.6-2.27-.33a1.82,1.82,0,1,1,3.37-1.39Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "198.307px 145.209px 0px",
            }}
            id="elm1eqzaj0pw"
            className="animable"
          />
          <path
            d="M209.69,136.63l3.33,2.13a1.89,1.89,0,0,1-2.67.65A2.08,2.08,0,0,1,209.69,136.63Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "211.215px 138.172px 0px",
            }}
            id="el6v2itisnxod"
            className="animable"
          />
          <path
            d="M194.71,140l3.23-2.28a1.89,1.89,0,0,1-.41,2.72A2.08,2.08,0,0,1,194.71,140Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "196.527px 139.262px 0px",
            }}
            id="elf5uv6dolwh6"
            className="animable"
          />
          <polygon
            points="204.57 142.75 204.71 153.22 210.59 151.25 204.57 142.75"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "207.58px 147.985px 0px",
            }}
            id="eltyfzk6b6fmq"
            className="animable"
          />
          <g id="el8iu7lu0zvrs">
            <path
              d="M208.11,148.6c-2.63,1.24-3.4,4.62-3.4,4.62l5.88-2-2-2.82A2.79,2.79,0,0,0,208.11,148.6Z"
              style={{
                opacity: 0.15,
                transformOrigin: "207.65px 150.81px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M191.23,151.56c.33,1.61,2.22,2.59,4.22,2.19s3.35-2,3-3.66-2.22-2.59-4.22-2.19S190.91,149.94,191.23,151.56Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "194.844px 150.824px 0px",
            }}
            id="el211pkfn741w"
            className="animable"
          />
          <path
            d="M212.15,147.76c-.15,1.64,1.37,3.13,3.4,3.32s3.8-1,4-2.62-1.37-3.13-3.4-3.32S212.31,146.12,212.15,147.76Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "215.853px 148.11px 0px",
            }}
            id="el89d85m01fco"
            className="animable"
          />
          <path
            d="M207.44,159.51c-.44,1.68-1.84,1.48-3.53,1s-3-.94-2.56-2.63a3.15,3.15,0,0,1,6.09,1.59Z"
            style={{
              fill: "rgb(177, 102, 104)",
              transformOrigin: "204.388px 158.253px 0px",
            }}
            id="el8wsigt109fu"
            className="animable"
          />
          <path
            d="M202.75,156.94a3.11,3.11,0,0,0-1.06.18,3.16,3.16,0,0,0-.34.8c-.44,1.69.88,2.19,2.56,2.63a9.69,9.69,0,0,0,1.53.29,3.07,3.07,0,0,0,.16-.8A3,3,0,0,0,202.75,156.94Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "203.433px 158.89px 0px",
            }}
            id="ellob3n4b0wm"
            className="animable"
          />
          <path
            d="M200.48,166.08c-4.14-.28-12.72-2.18-14.25-5.44a8.68,8.68,0,0,0,3.23,4.08c2.65,2,11.09,4.06,11.09,4.06Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "193.39px 164.71px 0px",
            }}
            id="elmhwpzo6o97"
            className="animable"
          />
          <path
            d="M264,199.34c-6.95-8.84-20.56-19.89-22.39-23.12a43.15,43.15,0,0,0-5.37-7.92c-.91-1-2-1.76-2.78-2.84l-3.08-4-.12-.17c-.32-.41-.73-.88-1.25-.85a1.11,1.11,0,0,0-.85.62,2.59,2.59,0,0,0-.21,1.07,10.5,10.5,0,0,0,.64,3.71c.37,1.11,1.87,3.08.67,3.33-5.3,1.1-11.77-1-17.18-1.2a3.8,3.8,0,0,0-2.24.39,2.55,2.55,0,0,0-1,1.89,8.84,8.84,0,0,0,.33,2.85,12.78,12.78,0,0,0,4.83,6.66c2.42,1.7,6.75,2.46,9.6,3.25s6.09,1.37,8.59,3.2c2.77,2,5,5.12,7,7.84,4,5.22,7.68,11.28,11.33,16.72,5.63,8.4,10.88,8.72,14.46,7.46S271,208.18,264,199.34Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "238.653px 189.608px 0px",
            }}
            id="el24xvuienhri"
            className="animable"
          />
          <g
            id="freepik--Thermometer--inject-102"
            style={{
              transformOrigin: "219.827px 154.009px 0px",
            }}
            className="animable"
          >
            <path
              d="M226.46,155.23,207,160.37c-.77.29-1-1.19,0-1.51l19.49-7.18Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "216.412px 156.044px 0px",
              }}
              id="el298quflnxy6"
              className="animable"
            />
            <path
              d="M223.2,153.91,207,159.33c-.25.1-.28.67,0,.6.57-.13,16.65-4.69,16.65-4.69Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "215.226px 156.923px 0px",
              }}
              id="elykrk8vopnw"
              className="animable"
            />
            <g id="elbppo9ptadc">
              <path
                d="M221.85,153.37l4.6-1.69v3.55l-3.44.91A4.82,4.82,0,0,1,221.85,153.37Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "224.15px 153.91px 0px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M223.6,152.49a4.86,4.86,0,1,0,4.84-4.88A4.86,4.86,0,0,0,223.6,152.49Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "228.46px 152.47px 0px",
              }}
              id="elk29qc5l8rzc"
              className="animable"
            />
            <path
              d="M225.62,152.48a2.84,2.84,0,1,0,2.83-2.85A2.83,2.83,0,0,0,225.62,152.48Z"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "228.46px 152.47px 0px",
              }}
              id="elhhddcnv8kic"
              className="animable"
            />
            <g id="el2104re4vyci">
              <path
                d="M225.62,152.48a2.84,2.84,0,1,0,2.83-2.85A2.83,2.83,0,0,0,225.62,152.48Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "228.46px 152.47px 0px",
                }}
                className="animable"
              />
            </g>
          </g>
          <g
            id="freepik--Scarf--inject-102"
            style={{
              transformOrigin: "195.947px 196.978px 0px",
            }}
            className="animable"
          >
            <path
              d="M182.1,182.2c2.26,4.68,9.76,15.79,12.25,28.61a153.36,153.36,0,0,1,2.57,19c.27,2.27,17.08-2.75,17.38-5.09s-1.36-13.42-3.77-21-5.74-18.45-10-22.37Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "198.218px 205.868px 0px",
              }}
              id="elo7ysunhqx1q"
              className="animable"
            />
            <g id="elv51mk5ekrdl">
              <path
                d="M182.1,182.2c2.26,4.68,9.76,15.79,12.25,28.61a153.36,153.36,0,0,1,2.57,19c.27,2.27,17.08-2.75,17.38-5.09s-1.36-13.42-3.77-21-5.74-18.45-10-22.37Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "198.218px 205.868px 0px",
                }}
                className="animable"
              />
            </g>
            <path
              d="M183.22,163.57c-1.7.55-2.67.75-3.65,3.8-.86,2.67-2.15,7.3-2,9,.27,2.63,3.35,6,8.64,7.78s14,.38,17.2-1.41c4.84-2.66,5.54-5.64,4.84-9.14a50.88,50.88,0,0,0-2.14-7.17c-2.14,0-4-.21-5.65-.38l.05,1.91s-1.35,1.16-6,1.48c-9.35.66-11.14-2.3-11.14-2.3Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "193.019px 174.272px 0px",
              }}
              id="elkgj84i4nbfq"
              className="animable"
            />
            <g id="el7u2eb2c734a">
              <path
                d="M190.43,173.3a15.2,15.2,0,0,0,12.63-2,2.93,2.93,0,0,0-.63-5l-.28,0-1.67-.16.05,1.91s-1.35,1.16-6,1.48c-9.35.66-11.14-2.3-11.14-2.3C182.94,167.5,184.19,171.65,190.43,173.3Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "193.749px 170.01px 0px",
                }}
                className="animable"
              />
            </g>
          </g>
          <g
            id="freepik--Arm--inject-102"
            style={{
              transformOrigin: "193.393px 238.376px 0px",
            }}
            className="animable"
          >
            <path
              d="M205.82,271.73c1.43-4.75,5.41-3.5,13.4.49s18.75,5.08,20.23,5.12c1.68,0,3.78,5-2,7.72s-6.56,3.56-7.91,7.4c-1.91,5.44-4.75,5.05-8.91,5.06a14.07,14.07,0,0,0-7.87,1.83c-6.37,3.1-9.67.66-9.67.66s3.3-9.21,2.91-17.77S204.89,274.8,205.82,271.73Z"
              style={{
                fill: "rgb(250, 250, 250)",
                transformOrigin: "222.169px 284.794px 0px",
              }}
              id="elypvbf17ppnn"
              className="animable"
            />
            <path
              d="M212.18,282.42c2.42-2.67,2.93-5,1.55-7.55l-8.14,1.57c.13,1.21.29,3,.42,5.8.05,1.16,0,2.33,0,3.48C208,285.09,210.76,284,212.18,282.42Z"
              style={{
                fill: "rgb(230, 230, 230)",
                transformOrigin: "210.037px 280.295px 0px",
              }}
              id="elqlsl8cl3iw"
              className="animable"
            />
            <path
              d="M230.72,289.75h0c1.06-1.78,2.65-2.77,6.74-4.69-4.12.29-11.8-4.36-16.86-8C220.6,277,225.74,286.55,230.72,289.75Z"
              style={{
                fill: "rgb(230, 230, 230)",
                transformOrigin: "229.03px 283.405px 0px",
              }}
              id="el2bbeuvizxer"
              className="animable"
            />
            <path
              d="M212.77,299.35a14.34,14.34,0,0,1,4.74-1.66,31.56,31.56,0,0,0-3.21-15.27c.66,6.73-.76,14.28-3.06,17.58A15.88,15.88,0,0,0,212.77,299.35Z"
              style={{
                fill: "rgb(230, 230, 230)",
                transformOrigin: "214.389px 291.21px 0px",
              }}
              id="elceb1s45niit"
              className="animable"
            />
            <path
              d="M173.74,176.06c-10.7,1.83-15.5,2.66-19.49,21.62-3.85,18.32-10,38.2-7.39,45.72s24.87,28.32,33.6,33.37,15.83,6.7,22.86,6.76c8.84.07,13.94-8.39,9.11-11.07-1.57-.88-3.3-.79-6.09-1.61-3.05-.89-6.6-1.58-10-3a17.63,17.63,0,0,0,6.14-1.83c1.23-.57,4.92-2.59,2.22-3.71a3.63,3.63,0,0,0-1.54-.17l-12.14.33c-1.95.05-3.63.22-5.45-.49a11.85,11.85,0,0,1-4.54-3.54c-1.3-1.53-2.53-3.14-3.82-4.7-6.08-7.38-12.25-16.43-12.25-16.43l8-32.46S179.32,188.29,173.74,176.06Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "180.263px 229.795px 0px",
              }}
              id="elv4979lpwt2"
              className="animable"
            />
            <path
              d="M174.55,175.83c-5.45,0-12,1.53-15.3,6.31s-4.82,12.34-8.82,29.34-4.92,25.16-4.89,29.45,8.36,12.33,8.36,12.33a36.07,36.07,0,0,1,15.25-10.11l-3.67-5.85s7.08-29.15,9.07-34.82S179.56,183,174.55,175.83Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "161.413px 214.545px 0px",
              }}
              id="elj8n68aww4wm"
              className="animable"
            />
            <g id="elxqzzzaaqgcp">
              <path
                d="M174.55,175.83c-5.45,0-12,1.53-15.3,6.31s-4.82,12.34-8.82,29.34-4.92,25.16-4.89,29.45,8.36,12.33,8.36,12.33a36.07,36.07,0,0,1,15.25-10.11l-3.67-5.85s7.08-29.15,9.07-34.82S179.56,183,174.55,175.83Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "161.413px 214.545px 0px",
                }}
                className="animable"
              />
            </g>
            <g id="eliz0027e6y0n">
              <path
                d="M165.48,237.3c-3-1.44-7.84,1.1-7.84,1.1s2.71-3,8.3-3Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "161.79px 236.9px 0px",
                }}
                className="animable"
              />
            </g>
          </g>
          <g
            id="freepik--shaking-chills--inject-102"
            style={{
              transformOrigin: "207.04px 227.644px 0px",
            }}
            className="animable"
          >
            <path
              d="M143.77,227.72a.51.51,0,0,1-.33-.11l-3.26-2.51a.51.51,0,0,1-.2-.46.52.52,0,0,1,.27-.43l3.31-1.88-3-2.89a.54.54,0,0,1-.16-.48.57.57,0,0,1,.31-.4l3.53-1.61-2.94-2.23a.54.54,0,0,1-.21-.49.53.53,0,0,1,.32-.43l3.9-1.73-2.88-2.81a.55.55,0,0,1,.15-.88l4.43-2a.54.54,0,0,1,.44,1L143.74,209l2.88,2.82a.52.52,0,0,1,.16.47.53.53,0,0,1-.31.4l-3.8,1.69,2.93,2.22a.52.52,0,0,1,.2.49.54.54,0,0,1-.3.43l-3.63,1.65,3,2.84a.53.53,0,0,1-.11.85l-3.24,1.84,2.61,2a.53.53,0,0,1,.1.75A.51.51,0,0,1,143.77,227.72Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "143.877px 217.027px 0px",
              }}
              id="elmd9dvd95zx"
              className="animable"
            />
            <path
              d="M271.75,207.48a.57.57,0,0,1-.22,0,.55.55,0,0,1-.28-.71l1.61-3.74-4-.13a.56.56,0,0,1-.44-.25.55.55,0,0,1,0-.5L270,198.3l-3.66.33a.52.52,0,0,1-.48-.21.51.51,0,0,1-.06-.53l1.55-3.67-4.09-.1a.54.54,0,0,1-.43-.23.55.55,0,0,1-.07-.47l1.15-3.55-3.29.28a.54.54,0,0,1-.58-.49.53.53,0,0,1,.49-.58l4.1-.34a.52.52,0,0,1,.46.2.53.53,0,0,1,.09.5L264,193.07l4.17.1a.56.56,0,0,1,.44.25.55.55,0,0,1,0,.5l-1.52,3.56,3.67-.33a.55.55,0,0,1,.49.22.53.53,0,0,1,.05.53l-1.71,3.91,4,.14a.53.53,0,0,1,.47.74l-1.91,4.47A.54.54,0,0,1,271.75,207.48Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "267.071px 198.114px 0px",
              }}
              id="elkf3880uuf7l"
              className="animable"
            />
            <path
              d="M154.84,266.52a.55.55,0,0,1-.38-.16.52.52,0,0,1-.14-.49l.79-3.73-4.16.34a.58.58,0,0,1-.46-.2.54.54,0,0,1-.09-.49l1.13-3.71-3.62.72a.54.54,0,0,1-.5-.17.52.52,0,0,1-.11-.52l1.29-4.07-4,.29a.54.54,0,0,1-.46-.2.52.52,0,0,1-.09-.49l1.43-4.64a.53.53,0,1,1,1,.31l-1.2,3.89,4-.29a.55.55,0,0,1,.46.2.56.56,0,0,1,.09.5l-1.26,4,3.61-.72a.54.54,0,0,1,.62.68l-1.17,3.82,4.09-.33a.5.5,0,0,1,.44.18.52.52,0,0,1,.13.46l-.78,3.65,3.25-.63a.54.54,0,1,1,.2,1.06l-4,.77Z"
              style={{
                fill: "rgb(186, 104, 200)",
                transformOrigin: "151.715px 257.548px 0px",
              }}
              id="elxwiu56adkbj"
              className="animable"
            />
          </g>
          <g
            id="freepik--Pain--inject-102"
            style={{
              transformOrigin: "154.54px 129.145px 0px",
            }}
            className="animable"
          >
            <polygon
              points="163.87 133.65 159.33 131.22 161.94 128.99 152.51 124.57 156.63 122.19 146.47 116.79 152.51 122.11 147.6 124.57 158.68 129.38 155.94 132.11 163.87 133.65"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "155.17px 125.22px 0px",
              }}
              id="elqfg2tuey7f"
              className="animable"
            />
            <polygon
              points="166.19 127.67 163.23 124.84 164.84 123.64 162.24 120.57 164.74 119.72 163.87 115.82 165.62 120.03 163.87 120.79 166.67 123.87 164.78 125.22 166.19 127.67"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "164.455px 121.745px 0px",
              }}
              id="elefzoj7v39jl"
              className="animable"
            />
            <polygon
              points="164.46 138.12 158.89 142.47 156.83 139.44 151.96 142.09 149.95 138.34 142.41 140.27 151.15 136.1 153.65 139.54 157.7 137.37 159.39 140.27 164.46 138.12"
              style={{
                fill: "rgb(242, 143, 143)",
                transformOrigin: "153.435px 139.285px 0px",
              }}
              id="el165fwuss13c"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="freepik--Tissues--inject-102"
      style={{
        transformOrigin: "295.149px 281.665px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--tissues--inject-102"
        style={{
          transformOrigin: "267.658px 332.415px 0px",
        }}
        className="animable"
      >
        <g id="eldwuuf1ir90b">
          <path
            d="M241.92,332.46a3.12,3.12,0,0,1-.48,1.29c-.76,1.74.49,3.74,2,4.84a11.39,11.39,0,0,0,9,1.56,19.15,19.15,0,0,0,8.2-4.48c2.16-1.9,4.17-4.71,3.25-7.43-.8-2.35-3.57-3.53-6-3.37s-4.75,1.35-7,2.39a15.06,15.06,0,0,1-7,1.42c-.85,0-2,.06-2.57.89C240.59,330.85,241.88,331.26,241.92,332.46Z"
            style={{
              opacity: 0.1,
              transformOrigin: "252.608px 332.667px 0px",
            }}
            className="animable"
          />
        </g>
        <g id="elv3e3alkk5c">
          <path
            d="M269.71,347.71c-.53,1.28.44,2.77,1.71,3.32a8.07,8.07,0,0,0,4.09.26,16.83,16.83,0,0,0,5.81-1.34,17,17,0,0,1,2.76-1.4c1.95-.59,4.08.25,6.08-.14a5.19,5.19,0,0,0,4.06-5l-17.5.07c-4.59,0-8.86,1.21-13.43,1.42C264.24,347.19,267.38,348.33,269.71,347.71Z"
            style={{
              opacity: 0.1,
              transformOrigin: "278.755px 347.425px 0px",
            }}
            className="animable"
          />
        </g>
        <path
          d="M244.93,326a4.13,4.13,0,0,0-.5.15,3.07,3.07,0,0,0-2,2,2.39,2.39,0,0,0,.08,1.45c.19.32.67.25.61.8a1.53,1.53,0,0,1-.55.92,2.73,2.73,0,0,0-.69.83,1.8,1.8,0,0,0,.82,2,14.62,14.62,0,0,1,1.9,1.27c.76.76,1.1,2,2.13,2.35a4,4,0,0,0,1.68-.09c1.28-.17,2.15.83,3.47.1.52-.28.92-.77,1.44-1a13.19,13.19,0,0,1,2.21-.54,11.28,11.28,0,0,0,2.09-1.1,13,13,0,0,0,3.5-3.28,12.82,12.82,0,0,0,2.51-9,7.89,7.89,0,0,0-2.37-5.07c-2.52-2.23-6.66-1.95-9-4.4.23,2.06.83,4.07,1,6.15a7.49,7.49,0,0,1-.26,3.09c-.63,1.62-1.87.19-3.06-.07a2.72,2.72,0,0,0-2.29.44,2.07,2.07,0,0,0-.28,2.79A11,11,0,0,0,244.93,326Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "252.759px 325.72px 0px",
          }}
          id="elyy65op0eekd"
          className="animable"
        />
        <path
          d="M253,322.59c-.29.75-.71.84-1.2.7h0s3.71,2.61,4.4,5c.91-3.78-2.94-8.83-2.94-8.83A7.49,7.49,0,0,1,253,322.59Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "254.07px 323.875px 0px",
          }}
          id="elvdl1dc0vp8a"
          className="animable"
        />
        <path
          d="M247.36,331s-2.6.07-3.35,4a3.23,3.23,0,0,1,.59.46c.57.57.91,1.44,1.48,2C245.26,336.28,245.42,331.89,247.36,331Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "245.685px 334.23px 0px",
          }}
          id="elqt5yudyri4m"
          className="animable"
        />
        <path
          d="M254.06,336.46h0a9.32,9.32,0,0,0,1.47-.29,8.84,8.84,0,0,0,1.35-.66,6.63,6.63,0,0,0-.26-4.18A5.88,5.88,0,0,1,254.06,336.46Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "255.581px 333.895px 0px",
          }}
          id="el8ybcus52wri"
          className="animable"
        />
        <path
          d="M251.79,327.92c-.86-3.08-4.75-4-4.76-4a2.09,2.09,0,0,0,.33,1.83,5.17,5.17,0,0,1,3.66,6.76S252.64,331,251.79,327.92Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "249.492px 328.215px 0px",
          }}
          id="eltmolr02it4s"
          className="animable"
        />
        <path
          d="M267.61,342a15.25,15.25,0,0,1-3.17.1c.54,1.27.55,1.94,1.59,2.83a5.1,5.1,0,0,0,4.74,1c.17,1.36.52,2.75,2,3.23a3,3,0,0,0,3.54-1.77,4,4,0,0,0,5.16.83c1.82-1.22,2.29-2.35,4.68-1.89,1.79.34,3.41.5,4.9-.79a10.31,10.31,0,0,0,2.53-4.14.25.25,0,0,0,0-.22c0-.08-.14-.09-.22-.1-3.13-.35-7.53-.23-9.38-3.36a12.83,12.83,0,0,1-.94-2.44,4.12,4.12,0,0,0-1.43-2.14,1.84,1.84,0,0,0-2.38.17,3.07,3.07,0,0,0-3.6-1.14,4,4,0,0,0-2.58,2.22c-.69,1.3-.66,2.88-1.26,4.24a5.59,5.59,0,0,1-3.87,3.3Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "279.023px 340.618px 0px",
          }}
          id="eludeioppyjhj"
          className="animable"
        />
        <path
          d="M289.39,346.44c-2.46-.63-6.58-4.12-8.05-7a10.87,10.87,0,0,0,2.28,7.21,3.36,3.36,0,0,1,2.56-.32A7.46,7.46,0,0,0,289.39,346.44Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "285.359px 343.045px 0px",
          }}
          id="ela3d2wulcb1s"
          className="animable"
        />
        <path
          d="M278.56,348.74c-1.6-2.11-1.47-9.29-1.47-9.29a19.69,19.69,0,0,0-.75,7.95A3.84,3.84,0,0,0,278.56,348.74Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "277.39px 344.095px 0px",
          }}
          id="el3my7zx185a6"
          className="animable"
        />
        <path
          d="M270.59,343.89a7.45,7.45,0,0,1-3.34,1.83,5.46,5.46,0,0,0,3.52.22c.54-2.11,4-6,4-6A18,18,0,0,0,270.59,343.89Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "271.01px 343.036px 0px",
          }}
          id="elpgnugo3xvq"
          className="animable"
        />
      </g>
      <g
        id="freepik--disposable-tissue-box--inject-102"
        style={{
          transformOrigin: "316.018px 240.905px 0px",
        }}
        className="animable"
      >
        <g id="elgd152sgefhu">
          <path
            d="M283.66,245.13l22.7-13a4.46,4.46,0,0,1,4,0l38,22a1.22,1.22,0,0,1,0,2.32l-22.71,13a4.49,4.49,0,0,1-4,0l-38-22A1.23,1.23,0,0,1,283.66,245.13Z"
            style={{
              opacity: 0.1,
              transformOrigin: "316.018px 250.788px 0px",
            }}
            className="animable"
          />
        </g>
        <polygon
          points="286.05 233.11 308.93 219.91 347.05 241.92 324.18 255.13 286.05 233.11"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "316.55px 237.52px 0px",
          }}
          id="el0ctr0zzh7l7b"
          className="animable"
        />
        <polygon
          points="286.05 246.32 324.18 268.33 324.18 255.13 286.05 233.11 286.05 246.32"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "305.115px 250.72px 0px",
          }}
          id="el6o7jjzrtoi7"
          className="animable"
        />
        <polygon
          points="347.05 241.92 324.18 255.13 324.18 268.33 347.05 255.13 347.05 241.92"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "335.615px 255.125px 0px",
          }}
          id="el9rb5dd97cel"
          className="animable"
        />
        <path
          d="M305.36,235.46,320.11,244a8.73,8.73,0,0,0,7.88.15c2.1-1.22,2-3.25-.25-4.55L313,231.06a8.73,8.73,0,0,0-7.88-.15C303,232.13,303.12,234.16,305.36,235.46Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "316.551px 237.53px 0px",
          }}
          id="el94bxwaa6i2a"
          className="animable"
        />
        <path
          d="M308.39,234.72S306,218.51,311,211.89c0,0,.89,4.74,3.15,5.63,3.7,1.45,7.39.34,9.49,2.77s1.16,4.13,3.82,6c1.62,1.11,6.36-.33,8.89,1.87,0,0-9.49,5.51-12.71,15.41Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "322.085px 227.73px 0px",
          }}
          id="el89fr5a1qke7"
          className="animable"
        />
        <path
          d="M320.43,218.68c-1.36-.25-2.9-.3-4.5-.64-2,5.22-1,14.1-1,14.1C315.26,226.65,318.53,219.87,320.43,218.68Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "317.555px 225.09px 0px",
          }}
          id="elt5qxxoqnoj"
          className="animable"
        />
        <path
          d="M327.46,226.25a6.22,6.22,0,0,1-.92-.77c-3.58,3.64-5.83,11-5.83,11,1.46-2.62,8.94-9.47,11.24-9.65C330.11,226.71,328.33,226.85,327.46,226.25Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "326.33px 230.98px 0px",
          }}
          id="elpeeph9uhhdc"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--speech-bubble--inject-102"
      style={{
        transformOrigin: "111.8px 130.4px 0px",
      }}
      className="animable"
    >
      <g
        id="freepik--speech-bubble--inject-102"
        style={{
          transformOrigin: "111.8px 130.4px 0px",
        }}
        className="animable"
      >
        <g
          id="freepik--speech-bubble--inject-102"
          style={{
            transformOrigin: "111.8px 130.4px 0px",
          }}
          className="animable"
        >
          <path
            d="M130.12,131.92a.66.66,0,0,0-.37-.1h-6.68l-2.75,1.59,1.58,10.44,2.76-1.59,2.39-2.76v6.75l1.88-.68,8.1-8.69a.74.74,0,0,0-.18-1.12Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "128.765px 139.035px 0px",
            }}
            id="elgmavuu1mpju"
            className="animable"
          />
          <g id="elg33faab1wss">
            <path
              d="M130.12,131.92a.66.66,0,0,0-.37-.1h-6.68l-2.75,1.59,1.58,10.44,2.76-1.59,2.39-2.76v6.75l1.88-.68,8.1-8.69a.74.74,0,0,0-.18-1.12Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.7,
                transformOrigin: "128.765px 139.035px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M127.05,146.25l1.88-.68,8.1-8.69a.73.73,0,0,0-.55-1.21h-7.55l-1.88,1.59Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "132.13px 140.96px 0px",
            }}
            id="elh52sxf2grcs"
            className="animable"
          />
          <g id="el24ifdnhwhm">
            <path
              d="M127.05,146.25l1.88-.68,8.1-8.69a.73.73,0,0,0-.55-1.21h-7.55l-1.88,1.59Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "132.13px 140.96px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M128.93,91.63a7,7,0,0,0-3.18-5.51h0a7.05,7.05,0,0,0-6.36,0l-29.82,17.1a7,7,0,0,0-3.18,5.51v60.44a7,7,0,0,0,3.18,5.51h0a7.05,7.05,0,0,0,6.36,0l30.12-17.31c2.86-1.63,2.88-3.27,2.88-5.3Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "107.66px 130.4px 0px",
            }}
            id="el2jc421j8am"
            className="animable"
          />
          <g id="ela2r7718cafa">
            <path
              d="M128.93,91.63a7,7,0,0,0-3.18-5.51h0a7.05,7.05,0,0,0-6.36,0l-29.82,17.1a7,7,0,0,0-3.18,5.51v60.44a7,7,0,0,0,3.18,5.51h0a7.05,7.05,0,0,0,6.36,0l30.12-17.31c2.86-1.63,2.88-3.27,2.88-5.3Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.4,
                transformOrigin: "107.66px 130.4px 0px",
              }}
              className="animable"
            />
          </g>
          <g id="elypgbwklbow">
            <path
              d="M86.39,169.17a7,7,0,0,0,3.18,5.51h0a7.14,7.14,0,0,0,5.82.26c-1.5.57-2.64-.29-2.64-2.1V112.4a6.6,6.6,0,0,1,.93-3.14l-6.36-3.67a6.46,6.46,0,0,0-.93,3.14Z"
              style={{
                opacity: 0.2,
                transformOrigin: "90.89px 140.514px 0px",
              }}
              className="animable"
            />
          </g>
          <path
            d="M128.83,90.73c-.37-1.36-1.6-1.79-3.07-.94l-29.83,17.1a6.29,6.29,0,0,0-2.24,2.38l-6.36-3.67a6.44,6.44,0,0,1,2.24-2.38l29.81-17.1a7.07,7.07,0,0,1,6.37,0h0A7,7,0,0,1,128.83,90.73Z"
            style={{
              fill: "rgb(186, 104, 200)",
              transformOrigin: "108.08px 97.316px 0px",
            }}
            id="el59l8cesjjgr"
            className="animable"
          />
          <g id="els3b55o3tkf8">
            <path
              d="M128.83,90.73c-.37-1.36-1.6-1.79-3.07-.94l-29.83,17.1a6.29,6.29,0,0,0-2.24,2.38l-6.36-3.67a6.44,6.44,0,0,1,2.24-2.38l29.81-17.1a7.07,7.07,0,0,1,6.37,0h0A7,7,0,0,1,128.83,90.73Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.7,
                transformOrigin: "108.08px 97.316px 0px",
              }}
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--thermometer--inject-102"
          style={{
            transformOrigin: "111.31px 133.331px 0px",
          }}
          className="animable"
        >
          <path
            d="M111.31,159.88c-4,2.31-7.25-.82-7.25-7a21.69,21.69,0,0,1,3.83-12V113.63c0-2.91,1.53-6.16,3.42-7.25s3.43.39,3.43,3.3v27.24c2.36.59,3.82,3.48,3.82,7.62C118.56,150.69,115.31,157.58,111.31,159.88Zm0-52.34c-1.47.85-2.67,3.39-2.67,5.66v28l-.21.28a19.37,19.37,0,0,0-3.62,11c0,5.52,2.92,8.33,6.5,6.26s6.5-8.24,6.5-13.76c0-3.82-1.38-6.45-3.61-6.87l-.21,0V110.11C114,107.84,112.79,106.68,111.31,107.54Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "111.31px 133.331px 0px",
            }}
            id="ellbz5cn93n4l"
            className="animable"
          />
          <g id="elasb0jcrnlqu">
            <g
              style={{
                opacity: 0.7,
                transformOrigin: "111.31px 133.338px 0px",
              }}
              className="animable"
            >
              <path
                d="M111.31,107.54c-1.47.85-2.67,3.39-2.67,5.66v28l-.21.28a19.37,19.37,0,0,0-3.62,11c0,5.52,2.92,8.33,6.5,6.26s6.5-8.24,6.5-13.76c0-3.82-1.38-6.45-3.61-6.87l-.21,0V110.11C114,107.84,112.79,106.68,111.31,107.54Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "111.31px 133.338px 0px",
                }}
                id="elp0u6mrv6co"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M112.25,142V113c0-.8-.42-1.21-.94-.91a2.48,2.48,0,0,0-.94,2v29a12.27,12.27,0,0,0-3.37,8.42c0,3.67,1.93,5.53,4.31,4.15s4.31-5.46,4.31-9.13C115.62,143.35,114.18,141.53,112.25,142Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "111.31px 134.054px 0px",
            }}
            id="el2pg43bmu6yv"
            className="animable"
          />
          <path
            d="M112.76,132.19a.38.38,0,0,1-.3-.16.37.37,0,0,1,.12-.49l1.57-.94a.35.35,0,0,1,.36.6l-1.57.94A.27.27,0,0,1,112.76,132.19Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "113.542px 131.373px 0px",
            }}
            id="elmehzqbk3puh"
            className="animable"
          />
          <path
            d="M112.76,127.82a.36.36,0,0,1-.3-.17.36.36,0,0,1,.12-.48l1.57-.94a.35.35,0,0,1,.48.11.34.34,0,0,1-.12.48l-1.57,1A.27.27,0,0,1,112.76,127.82Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "113.549px 127.006px 0px",
            }}
            id="elsoukezxefy"
            className="animable"
          />
          <path
            d="M112.76,123.45a.36.36,0,0,1-.3-.17.36.36,0,0,1,.12-.48l1.57-1a.37.37,0,0,1,.48.12.34.34,0,0,1-.12.48l-1.57,1A.35.35,0,0,1,112.76,123.45Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "113.549px 122.603px 0px",
            }}
            id="elch9s8q41oi"
            className="animable"
          />
          <path
            d="M112.76,119.08a.36.36,0,0,1-.3-.17.36.36,0,0,1,.12-.48l1.57-1a.35.35,0,1,1,.36.6l-1.57,1A.35.35,0,0,1,112.76,119.08Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "113.551px 118.227px 0px",
            }}
            id="elzx2x7h8axeh"
            className="animable"
          />
          <path
            d="M112.76,114.71a.36.36,0,0,1-.3-.17.35.35,0,0,1,.12-.48l1.57-1a.35.35,0,0,1,.36.6l-1.57,1A.35.35,0,0,1,112.76,114.71Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "113.541px 113.863px 0px",
            }}
            id="el02tr93zfc08i"
            className="animable"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
    <defs>
      <clipPath id="freepik--clip-path--inject-102">
        <path
          d="M295,145.08a3.33,3.33,0,0,1,2-2.74,10.51,10.51,0,0,1,9.49,0,3.33,3.33,0,0,1,2,2.74h0v3h0a3.31,3.31,0,0,1-2,2.74,10.51,10.51,0,0,1-9.49,0,3.31,3.31,0,0,1-2-2.74h0v-3Z"
          style={{
            fill: "none",
          }}
        />
      </clipPath>
    </defs>
  </svg>
)
export default PatientCountAnimated
